import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalBody,
  ModalHeader,
  Col,
  Row,
  Button,
} from "reactstrap";
import Select from "react-select";
import ButtonSpinner from "../../../../components/Buttons/ButtonSpinner";

export default function ModalAddGroups({
  modalAddGroupsControl,
  setModalAddGroupsControl,
  groups,
  trySaveGroups,
}) {
  return (
    <Modal
      isOpen={modalAddGroupsControl.open}
      toggle={() => {
        toggleBackdrop();
      }}
      autoFocus={true}
      centered={true}
    >
      <ModalHeader>Adicionar Grupos</ModalHeader>
      <ModalBody>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            trySaveGroups(e);
          }}
        >
          <Row style={{ marginBottom: 10 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Grupos</label>
                <Select
                  value={modalAddGroupsControl.groups}
                  placeholder={"Selecione"}
                  isMulti={true}
                  onChange={(e) => setModalAddGroupsControl({ ...modalAddGroupsControl, groups: e })}
                  options={[
                    {
                      options: [
                        { label: "TODOS", value: "todos" },
                        ...groups.map((e) => {
                          return { label: e.name, value: e.id };
                        }),
                      ],
                    },
                  ]}
                  classNamePrefix="select2-selection"
                />
              </div>
            </Col>
          </Row>

          <Row
            style={{
              width: "100%",
              margin: "auto",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              color="danger"
              style={{ width: 80, marginRight: 10 }}
              onClick={() => setModalAddGroupsControl({ ...modalAddGroupsControl, open: false })}
            >
              Fechar
            </Button>
            <ButtonSpinner
              // isLoading={isLoading} 
              title={"Salvar"}
            />
          </Row>
        </form>
      </ModalBody>
    </Modal>
  )
}
